// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.sketch-with-eye-dropper__picker {
  width: 200px;
  position: relative;
  padding: 10px 10px 0;
  box-sizing: initial;
  border-radius: 4px;
}
.sketch-with-eye-dropper__controls {
  display: flex;
}
.sketch-with-eye-dropper__inputs {
  display: flex;
  align-items: baseline;
}
.sketch-with-eye-dropper__inputs input {
  background-color: var(--color-input-background);
  color: var(--color-content-base);
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  height: 32px;
  padding: 0 5px;
  height: 14px;
  line-height: normal;
  /** we need to override the box-shadow from library */
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base) !important;
}
.sketch-with-eye-dropper__inputs input--disabled {
  opacity: 0.5;
}
.sketch-with-eye-dropper__inputs input--plain {
  box-shadow: none;
}
.sketch-with-eye-dropper__inputs input--hide-arrows::-webkit-outer-spin-button,
.sketch-with-eye-dropper__inputs input--hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome & Safari */
}
.sketch-with-eye-dropper__inputs input--hide-arrows[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}
.sketch-with-eye-dropper__inputs input--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.sketch-with-eye-dropper__inputs input--variant-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.sketch-with-eye-dropper__inputs input--variant-medium {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.sketch-with-eye-dropper__inputs input--variant-large {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.sketch-with-eye-dropper__inputs input--focused,
.sketch-with-eye-dropper__inputs input:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.sketch-with-eye-dropper__saturation {
  width: 100%;
  padding-bottom: 75%;
  position: relative;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15), inset 0 0 4px rgba(0, 0, 0, 0.25);
}
.sketch-with-eye-dropper__sliders {
  padding: 4px 0;
  flex: 1;
}
.sketch-with-eye-dropper__hue {
  height: 10px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15), inset 0 0 4px rgba(0, 0, 0, 0.25);
}
.sketch-with-eye-dropper__active-color-wrapper {
  width: 24px;
  position: relative;
  margin-top: 4px;
  margin-left: 4px;
  border-radius: 3px;
  height: 10px;
}
.sketch-with-eye-dropper__active-color {
  position: absolute;
  inset: 0;
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15), inset 0 0 4px rgba(0, 0, 0, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/form-inputs/ColorPicker/SketchWithEyeDropper.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/input.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAQJ;AALE;EACE,aAAA;AAOJ;AAJE;EACE,aAAA;EACA,qBAAA;AAMJ;AARE;ECZA,+CAAA;EACA,gCAAA;EACA,qFAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAGE,cAAA;EDQE,YAAA;EACA,mBAAA;EAcJ,qDAAqD;EAZjD,gGAAA;AAcN;ACtBE;EACE,YAAA;ADwBJ;ACrBE;EACE,gBAAA;ADuBJ;ACnBI;;EAEE,wBAAA;EDqBJ,oBAAoB;AACtB;ACnBI;EACE,0BAAA;EDqBJ,YAAY;AACd;AClBE;EACE,iGAAA;EACA,oDAAA;ADoBJ;ACjBE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADmBJ;AChBE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADkBJ;ACfE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADiBJ;ACdE;;EC1DA,mBAAA;EACA,4CAAA;AF4EF;AAjDE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kFAAA;AAmDJ;AA9CE;EACE,cAAA;EACA,OAAA;AAgDJ;AA7CE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kFAAA;AA+CJ;AA1CE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AA4CJ;AAzCE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,kFAAA;AA2CJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.sketch-with-eye-dropper {\n  &__picker {\n    width: 200px;\n    position: relative;\n    padding: 10px 10px 0;\n    box-sizing: initial;\n    border-radius: 4px;\n  }\n\n  &__controls {\n    display: flex;\n  }\n\n  &__inputs {\n    display: flex;\n    align-items: baseline;\n\n    input {\n      .neptune-input();\n\n      height: 14px;\n      line-height: normal;\n      /** we need to override the box-shadow from library */\n      box-shadow: @input-box-shadow !important;\n    }\n  }\n\n  &__saturation {\n    width: 100%;\n    padding-bottom: 75%;\n    position: relative;\n    overflow: hidden;\n    border-radius: 3px;\n    box-shadow:\n      inset 0 0 0 1px rgba(0, 0, 0, 0.15),\n      inset 0 0 4px rgba(0, 0, 0, 0.25);\n  }\n\n  &__sliders {\n    padding: 4px 0;\n    flex: 1;\n  }\n\n  &__hue {\n    height: 10px;\n    overflow: hidden;\n    position: relative;\n    box-shadow:\n      inset 0 0 0 1px rgba(0, 0, 0, 0.15),\n      inset 0 0 4px rgba(0, 0, 0, 0.25);\n  }\n\n  &__active-color-wrapper {\n    width: 24px;\n    position: relative;\n    margin-top: 4px;\n    margin-left: 4px;\n    border-radius: 3px;\n    height: 10px;\n  }\n\n  &__active-color {\n    position: absolute;\n    inset: 0;\n    border-radius: 2px;\n    box-shadow:\n      inset 0 0 0 1px rgba(0, 0, 0, 0.15),\n      inset 0 0 4px rgba(0, 0, 0, 0.25);\n  }\n}\n","@import \"./../variables.less\";\n\n.neptune-input(@with-padding: true) {\n  background-color: var(--color-input-background);\n  color: var(--color-content-base);\n  box-shadow: @input-box-shadow;\n  line-height: 32px;\n  font-size: @fontSize-sm;\n  font-weight: @fontWeight-regular;\n  border-radius: @input-border-radius;\n  border: none;\n  height: 32px;\n\n  & when (@with-padding = true) {\n    padding: 0 5px;\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &--plain {\n    box-shadow: none;\n  }\n\n  &--hide-arrows {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none; /* Chrome & Safari */\n    }\n\n    &[type=number] {\n      -moz-appearance: textfield; /* Firefox */\n    }\n  }\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n  }\n\n  &--variant-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--variant-medium {\n    height: @layoutUnit-xl;\n    line-height: @layoutUnit-xl;\n    border-radius: 4px;\n  }\n\n  &--variant-large {\n    height: @layoutUnit-xxl;\n    line-height: @layoutUnit-xxl;\n    border-radius: 4px;\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n}\n\n.neptune-input-select() {\n  .neptune-input(@with-padding: false);\n\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  user-select: none;\n\n  padding: 6px 8px;\n\n  &[data-placeholder] {\n    color: var(--color-content-secondary);\n  }\n\n  &__icon {\n    color: var(--color-content-secondary);\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
